import { useParams } from 'react-router';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { PermissoesFormComp, PermissoesListComp } from 'pages/cadastro/permissoes/components';

export function PermissoesForm() {
    const { hasFormPermission, alertNotPermission } = usePermissionsContext();
    const { id } = useParams();

    if (!hasFormPermission('GRUPO_PERMISSAO', id)) return alertNotPermission();

    return (
        <FormProvider>
            <PermissoesFormComp />
        </FormProvider>
    );
}

export function PermissoesList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['GRUPO_PERMISSAO_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <PermissoesListComp />
        </ListagemProvider>
    );
}
